module.exports = __webpack_public_path__ + "img/qilin-stage4-hungry.9ace0ebd.png";